// import React from "react";
import { DatePicker } from "antd";
import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";



import { editEvents, getOneEvents } from "../../../redux/actions/authActions";


const EditCalendarHome = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const { events } = useSelector((state) => state.auth);
    const [formData, setFormData] = useState({
      name: "",
      description: "",
      date: ""
  });

  const onChange = (e) => {
    const { id, value } = e.target;
  
    if (id === "name" || id === "description") {
      // Allow only letters and spaces
      const lettersOnly = value.replace(/[^a-zA-Z\s]/g, "");
      setFormData({ ...formData, [id]: lettersOnly });
    } else {
      setFormData({ ...formData, [id]: value });
    }
  };
  //eslint-disable-next-line
  const onDateChange = (date, dateString) => {
    setFormData({ ...formData, date: dateString });
  };
  

    useEffect(() => {
        dispatch(getOneEvents(id));
      }, [dispatch,id]);
    
      useEffect(() => {
        if (events) {
          setFormData({
            name: events.name,
            description: events.description,
            date: events.date,
          })
        }
      }, [events])
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        try {
          await dispatch(editEvents(id, formData));
          navigate("/calendar");
        } catch (error) {
          console.error("Error in handleSubmit:", error);
        }
      }
    
  
  return (
    <form onSubmit={handleSubmit}>

    
      <div className="container w-full md:w-1/2 lg:w-1/3  text-start">
        <div class="my-5">
          <label
            for="email"
            class="block mb-2 text-sm font-medium text-gray-900 "
          >
            Event Title
          </label>
          <input
            type="text"
            id="name"
            onChange={onChange}
            value={formData.name}
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
            // onChange={(e)=>onChange(e.target.value,"name")}

            placeholder="Enter Client name"
            required
          />
        </div>

        <div class="mb-5">
          <label for="" class="block mb-2 text-sm font-medium text-gray-900 ">
            Event Date
          </label>
          <DatePicker
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
            onChange={(date)=>onChange(date,"date")}
          />
        </div>

        <div class="my-5">
          <label
            for="email"
            class="block mb-2 text-sm font-medium text-gray-900 "
          >
            Description
          </label>
          <textarea
            type="text"
            id="description"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 "
            // onChange={(e)=>onChange(e.target.value,"description")}
            onChange={onChange}
            value={formData.description}
            placeholder="Enter Description"
            required
          />
        </div>

        <button
          type="submit"
          className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-sm font-medium text-white bg-[#045B9B] hover:bg-[#3385c0] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
         Edit Event
        </button>
      </div>
    </form>
  );
};

export default EditCalendarHome;
